/**
 * Show / Travel / Off for each date of a tour, decided the same way as the calendar's day cards.
 * Pure helpers — no React, no Firestore.
 */
import { findTourDayByDate, getLodgingVenueForDay, getInterDayTravelSummary, venueHasLodgingFlag } from './tourDayLodgingUtils';
import { classifyTourDayKind } from './calendarDayCard';
import { tourDayKeys } from './expenseItems';

/** The show venue for a day: the first named venue that isn't the hotel. */
export function pickShowVenue(venues, lodging) {
  const list = Array.isArray(venues) ? venues : [];
  const lodgingId = lodging ? String(lodging.id || '') : '';
  return list.find((v) => {
    const n = String(v?.name || '').trim();
    if (!n) return false;
    if (lodgingId && String(v.id || '') === lodgingId) return false;
    if (venueHasLodgingFlag(v) && list.length > 1) return false;
    return true;
  }) || null;
}

/** 'show' | 'travel' | 'off' for a date inside the tour's range (matches MyCalendar's buildCardForTourDate). */
export function tourDayKindFor(tour, dateKey) {
  const { day, dayIndex } = findTourDayByDate(tour, dateKey);
  const lodging = day ? getLodgingVenueForDay(day) : null;
  const showVenue = pickShowVenue(day?.venues, lodging);
  const travel = dayIndex >= 0 ? getInterDayTravelSummary(tour, dayIndex) : null;
  const hasTravel = Boolean(travel && !travel.same && (travel.fromLabel || travel.toLabel));
  return classifyTourDayKind({ hasShowVenue: Boolean(String(showVenue?.name || '').trim()), hasTravel, inTourRange: true });
}

/** { dateKey: kind } for every day from the tour's first to last scheduled date. */
export function tourDayKinds(tour) {
  const out = {};
  tourDayKeys(tour).forEach((key) => { out[key] = tourDayKindFor(tour, key); });
  return out;
}
